import { ExploreEcosystem } from "../components/site/ExploreEcosystem";
import { PageHero } from "../components/site/Shared";

export default function Explore() {
  return (
    <div data-testid="explore-page">
      <PageHero
        overline="Product Prototypes"
        title="Experience PARTECON."
        sub="Step inside the interactive product built for every stakeholder — Master &amp; School Administration, Principal, Teacher, Student and Parent. Open any prototype in a new tab."
      />
      <ExploreEcosystem />
    </div>
  );
}
